module.exports = __webpack_public_path__ + "img/icon7.6a7ccf7f.png";